import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import getMailboxCalendarConfigurationOperation from 'owa-service/lib/operation/getMailboxCalendarConfigurationOperation';
import GetMailboxCalendarConfigurationResponse from 'owa-service/lib/contract/GetMailboxCalendarConfigurationResponse';

export default async function getMailboxCalendarConfiguration(): Promise<
    MailboxCalendarConfiguration
> {
    let response: GetMailboxCalendarConfigurationResponse = await getMailboxCalendarConfigurationOperation();
    if (response.ErrorCode) {
        return null;
    } else {
        return response.Options;
    }
}
